/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Day
 */
export interface Day {
    /**
     * Unique identifier for the day
     * @type {string}
     * @memberof Day
     */
    readonly id: string;
    /**
     * Day number in the itinerary sequence
     * @type {number}
     * @memberof Day
     */
    number: number;
    /**
     * Title of the day
     * @type {string}
     * @memberof Day
     */
    title?: string;
    /**
     * Description of the day activities
     * @type {string}
     * @memberof Day
     */
    description: string;
    /**
     * Timestamp when the day was created
     * @type {Date}
     * @memberof Day
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the day was last updated
     * @type {Date}
     * @memberof Day
     */
    readonly updatedAt: Date;
    /**
     * ID of the parent itinerary
     * @type {string}
     * @memberof Day
     */
    readonly itineraryId: string;
    /**
     * IDs of stops associated with this day
     * @type {Array<string>}
     * @memberof Day
     */
    stopIds: Array<string>;
    /**
     * Number of stops associated with this day
     * @type {number}
     * @memberof Day
     */
    stopsCount: number;
}

/**
 * Check if a given object implements the Day interface.
 */
export function instanceOfDay(value: object): value is Day {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('itineraryId' in value) || value['itineraryId'] === undefined) return false;
    if (!('stopIds' in value) || value['stopIds'] === undefined) return false;
    if (!('stopsCount' in value) || value['stopsCount'] === undefined) return false;
    return true;
}

export function DayFromJSON(json: any): Day {
    return DayFromJSONTyped(json, false);
}

export function DayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Day {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'itineraryId': json['itineraryId'],
        'stopIds': json['stopIds'],
        'stopsCount': json['stopsCount'],
    };
}

  export function DayToJSON(json: any): Day {
      return DayToJSONTyped(json, false);
  }

  export function DayToJSONTyped(value?: Omit<Day, 'id'|'createdAt'|'updatedAt'|'itineraryId'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'title': value['title'],
        'description': value['description'],
        'stopIds': value['stopIds'],
        'stopsCount': value['stopsCount'],
    };
}

